export default function Aside() {
	const images = [
		'/testimonials_aryan.webp',
		'/testimonials_sophia.webp',
		'/testimonials_shivank.webp',
	]
	const randomIndex = Math.floor(Math.random() * images.length)
	const randomImage = images[randomIndex]

	return (
		<div className="shadow-small sticky top-0 hidden h-screen w-full flex-col-reverse overflow-hidden p-0 lg:flex lg:w-1/3">
			<img
				className="absolute inset-0 h-full w-full object-cover"
				src={randomImage}
				alt="Random background"
			/>
		</div>
	)
}
